var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrusteroLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trustero_logo_mini_group1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trustero_logo_mini_group2",
    transform: "translate(11.000000, 6.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8411304,1.26461795e-06 C12.4141949,-0.00292450545 4.81540228,5.07108644 1.58852531,12.8557197 C-1.63835166,20.640353 0.142269245,29.6023073 6.0999777,35.5620859 C12.0576862,41.5218644 21.0190214,43.3055986 28.8047752,40.0814263 C36.590529,36.8572539 41.66718,29.2602245 41.66718,20.8332885 C41.66718,9.33020771 32.3442104,0.00399804292 20.8411304,1.26461795e-06 Z M20.8411304,33.7066548 C15.6300979,33.7095794 10.9306856,30.572395 8.93515761,25.7585882 C6.93962961,20.9447814 8.04117916,15.4028512 11.7259361,11.7180942 C15.4106931,8.03333723 20.9526233,6.93178768 25.7664302,8.92731568 C30.580237,10.9228437 33.7174214,15.622256 33.7144967,20.8332885 C33.7105024,27.9413969 27.9492389,33.7026605 20.8411304,33.7066548 L20.8411304,33.7066548 Z",
    id: "trustero_logo_mini_path1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "trustero_logo_mini_polygon1",
    transform: "translate(21.217418, 48.515725) rotate(-90.000000) translate(-21.217418, -48.515725) ",
    points: "17.7331428 41.7570281 24.7016924 41.7570281 24.7016924 55.2744223 17.7331428 55.2744223"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrusteroLogoMini);
export default __webpack_public_path__ + "static/media/trustero_logo_mini.26fb4728.svg";
export { ForwardRef as ReactComponent };